export default __webpack_public_path__ + "static/media/available_hover_noeld_selected.de840335.svg";